import type {
  AutoIdPropertySettings,
  CalculatedPropertySettings,
  OwnershipPropertySettings,
  PicklistPropertySettings,
  PropertySettings,
  TextPropertySettings
} from 'state/selectedTemplate/selectedTemplateStore';

import { EPropertySettingTypes, EPropertySettingTypesLabels } from './EPropertySettingTypes';

export function isPicklistSettings(settings: PropertySettings): settings is PicklistPropertySettings {
  return settings.$type === EPropertySettingTypes.Picklist;
}

export function isAutoIdSettings(settings: PropertySettings): settings is AutoIdPropertySettings {
  return settings.$type === EPropertySettingTypes.AutoId;
}

export function isOwnershipSettings(settings: PropertySettings): settings is OwnershipPropertySettings {
  return settings.$type === EPropertySettingTypes.Ownership;
}

export function isCalculatedSettings(settings: PropertySettings): settings is CalculatedPropertySettings {
  return settings.$type === EPropertySettingTypes.Calculated;
}

export function isTextSettings(settings: PropertySettings): settings is TextPropertySettings {
  return settings.$type === EPropertySettingTypes.Text;
}

export function getSettingsType(settings: PropertySettings): string {
  return EPropertySettingTypesLabels[settings.$type];
}

/**
 * Property setting types whose value is set automatically, so they can't be typed into
 * manually. Used to block flows that require typing/matching a primary property's value
 * (one-click node creation, linking nodes) when the primary property has one of these types.
 */
export const AUTOMATICALLY_SET_PROPERTY_SETTING_TYPES = [
  EPropertySettingTypes.AutoId,
  EPropertySettingTypes.Calculated
] as const;

export type AutomaticallySetPropertySettingType = (typeof AUTOMATICALLY_SET_PROPERTY_SETTING_TYPES)[number];

export function getAutomaticallySetPropertySettingType(
  settings: PropertySettings
): AutomaticallySetPropertySettingType | undefined {
  return AUTOMATICALLY_SET_PROPERTY_SETTING_TYPES.find((type) => type === settings.$type);
}
